/**
 * Display text used by common notification UI.
 */
export const NOTIFICATION_TEXT = {
  closeLabel: 'Close notification',
} as const;